export default __webpack_public_path__ + "static/media/roboto-v27-latin-700.0344cc3c.woff";